module.exports = __webpack_public_path__ + "media/Video 24.81513a60.mp4";